import { createRequire } from 'node:module';
import { dirname, resolve } from 'node:path';
import { fileURLToPath } from 'node:url';

const __dirname = dirname(fileURLToPath(import.meta.url));

const require = createRequire(import.meta.url);

export const libDir = resolve(__dirname, '../../..');
export const libPkg = require(resolve(libDir, 'package.json'));

export default libPkg;
